// Mirrors artifacts/ccs-pharmacy/src/types/booking.ts field-for-field.
// This is the SAME top-level `/pharmacies/{id}` record the mobile app and
// public booking site read/write — see lib/bookingData.ts for how the
// Chain Admin panel resolves + reads it (client-side, public read rules)
// and lib/callables.ts for the admin write path (server-side callables).

export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const DAY_NAMES: Record<DayOfWeek, string> = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export interface AvailabilityWindow {
  dayOfWeek: DayOfWeek;
  startTime: string;
  endTime: string;
}

export interface BlockoutDate {
  date: string;
  reason?: string;
}

/**
 * One-time override of the recurring weekly `windows` for a single ISO week
 * (Monday-start). Mirrors functions/src/types/booking.ts and
 * ccs-pharmacy/src/types/booking.ts — keep in sync. When present for the
 * week containing a date, its `windows` FULLY REPLACE the recurring
 * schedule for every day that week (empty = unavailable that whole week),
 * even though the recurring `windows` shown elsewhere in the UI look
 * unchanged. This was previously not read or displayed anywhere in Chain
 * Admin, so a pharmacist-set override (including one that zeroes out an
 * upcoming week) was invisible here — the schedule "looked fine" while the
 * patient booking link correctly showed no times for those dates.
 */
export interface WeeklyAvailabilityOverride {
  weekStartDate: string;
  windows: AvailabilityWindow[];
}

export interface BookingPharmacy {
  id: string;
  name: string;
  address: string;
  eircode: string;
  slug: string;
  primaryColor?: string;
  logoUrl?: string;
  ownerUid: string;
  ccsPharmacyId?: string;
  chainId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BookingRoom {
  id: string;
  pharmacyId: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
}

export interface RoomAvailability {
  id: string;
  pharmacyId: string;
  roomId: string;
  pharmacistId?: string;
  windows: AvailabilityWindow[];
  blockoutDates: BlockoutDate[];
  updatedAt: string;
}
